exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".font-bold[data-v-392a726d]{font-weight:700;font-size:18px}.bg-success.bg-opacity-75[data-v-392a726d]{background-color:#c8e6c9!important}", ""]);

// exports
